'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMessageInThreadHistory = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _ifThen = require('transmute/ifThen');

var _ifThen2 = _interopRequireDefault(_ifThen);

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _pubNubMessageKeyInvariant = require('../../invariants/pubNubMessageKeyInvariant');

var _pubNubMessageRecordInvariant = require('../../invariants/pubNubMessageRecordInvariant');

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _sortMessages = require('./sortMessages');

var _setMessage = require('./setMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Update a message in a ThreadHistory and conditionally sort if the message is not an
 * INITIAL_MESSAGE.
 *
 * Multiple INITIAL_MESSAGE's may be added to the ThreadHistory prior to Publishing.
 * Skipping sort on these messages preserves the order as they are sequentially published.
 *
 * @param {PubNubMessageKey} messageKey
 * @param {PubNubMessageRecord} message
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var updateMessageInThreadHistory = exports.updateMessageInThreadHistory = (0, _curry2.default)(function (messageKey, message, threadHistory) {
  (0, _pubNubMessageKeyInvariant.pubNubMessageKeyInvariant)(messageKey);
  (0, _pubNubMessageRecordInvariant.pubNubMessageRecordInvariant)(message);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  return (0, _pipe2.default)((0, _setMessage.setMessage)(messageKey, message), (0, _ifThen2.default)(function () {
    return !(0, _messageTypeComparators.isInitialMessage)(message);
  }, _sortMessages.sortMessages))(threadHistory);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/updateMessageInThreadHistory.js
// module id = 890
// module chunks = 2 3